<template>
	<div class="card-container">
		<div class="main-img">
			<van-image fit="fill" width="100%" height="100%" :src="goodItem.img_url" />
			<numberRankFlag class="rank-flag" :number="goodItem.rank" />
		</div>
		<div class="label-wrapper">
			<!-- NOTE 超出两行省略号 -->
			<div class="product-name">{{ goodItem.product_name }}</div>
			<div class="rate-wrapper">
				<van-rate :value="goodItem.score" class="rate" />
				<commentCountLabel :count="goodItem.review_total" />
			</div>
			<div class="desc">
				<!-- NOTE 超出一行... -->
				<div class="desc-item-text">作者 | {{ goodItem.author }}</div>
				<div class="desc-item-text second-text">出版 | {{ goodItem.publisher }}</div>
			</div>
			<div class="price-wrapper"><numberStyle class="main-price" :number="goodItem.price.dangdang_price" color="#000000" /> <numberStyle :number="goodItem.price.original_price" isCrossedPrice labelSize="22" /></div>
			<div class="tag-wrapper">
				<van-tag v-for="(item, index) of goodItem.product_tags" :key="index" :plain="item.type == 1" color="#FF463C">{{ item.name }}</van-tag>
			</div>
			<div class="ebook-label" v-if="goodItem.price.ebook_price">电子书版 ¥{{ goodItem.price.ebook_price }}</div>
		</div>
	</div>
</template>

<script>
import numberRankFlag from "./number-rank-flag.vue";
import numberStyle from "@/h5Components/cur-components/number-style.vue";
import commentCountLabel from "./commentCountLabel.vue";
export default {
	name: "goodCard",
	components: {
		numberRankFlag,
		numberStyle,
		commentCountLabel,
	},
	props: {
		goodItem: {
			type: Object,
			default: () => ({}),
		},
	},
};
</script>

<style lang="less" scoped>
@import "~@/styles/ellipsis.less";
::v-deep .van-rate__icon {
	font-size: 20px;
}
::v-deep .van-tag {
	font-size: 18px;
	height: 24px;
	line-height: 100%;
	padding: 0 4px;
}
.card-container {
	display: flex;
	padding-top: 24px;
	padding-bottom: 24px;
	background: #fff;
	.main-img {
		width: 260px;
		height: 260px;
		position: relative;
		.rank-flag {
			position: absolute;
			top: 0;
			left: 16px;
		}
	}
	.label-wrapper {
		flex: 1;
		margin-left: 24px;
		.product-name {
			margin-top: 10px;
			font-size: 28px;
			font-weight: 550;
			color: #141414;
			.multi-ellipsis();
		}
		.rate-wrapper {
			margin-top: 14px;
			display: flex;
			align-items: center;
			.rate {
				margin-right: 12px;
			}
		}
		.desc {
			margin-top: 18px;
			font-size: 22px;
			line-height: 24px;
			color: #828282;
			.desc-item-text{
				.multi-ellipsis(1);
				&.second-text {
					margin-top: 5px;
				}
			}
		}
		.price-wrapper {
			margin-top: 32px;
			.main-price {
				margin-right: 6px;
			}
		}
		.tag-wrapper {
			margin-top: 14px;
			> :not(:first-child) {
				margin-left: 8px;
			}
		}
		.ebook-label {
			margin-top: 18px;
			font-size: 20px;
			color: #00c29a;
		}
	}
}
</style>
